;$(function() {
	$('.row-gallery').each(function() {
		let extraCount = $(this).find('.row-gallery__item').length - 5;
		if (extraCount > 0) {
			$('<div>', {
				class: 'row-gallery__overlay',
				text: '+' + extraCount
			}).appendTo($(this).find('.row-gallery__item:nth-of-type(5)'));
		}
	});
});